import {
  updateLoading,
  updateTotalItems,
  updateTotalPage,
} from "../redux/slices/paginationSlice";
import { toast } from "react-toastify";
import moment from "moment";
import CommonAPI from "services/CommonAPI";

const commonAPIInstance = new CommonAPI(); // ✅ create instance here

class Helper {
  // Capitalize First Letter
  capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  // Download Files
  downloadFiles(url) {
    const link = document.createElement("a");
    link.href = url;
    link.download = url;
    link.target = "_blank";
    link.click();
  }

  // Update Pagination
  updatePagination(totalPages, totalRecords, dispatch) {
    dispatch(updateTotalPage(totalPages));
    dispatch(updateTotalItems(totalRecords));
    dispatch(updateLoading(false));
  }

  // Calculate Three Month Salary Average
  calculateThreeMonthSalaryAverage(salaries) {
    if (salaries.length > 0) {
      let total = 0;

      for (let i = 0; i < salaries.length; i++) {
        total += parseInt(salaries[i]);
      }

      const average = total / salaries.length;
      return Math.round(average);
    }
  }

  // Generate EMI Repayment Date
  generateEMIRepaymentDate() {
    const dates = [];
    for (let i = 1; i <= 31; i++) {
      dates.push(i);
    }
    return dates;
  }

  // Copy Link
  handleCopy(value) {
    if (value) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          toast.success("Copied!");
        })
        .catch(() => {
          toast.error("Failed to copy");
        });
    }
  }

  // Add Query String
  addQueryString(key, value) {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    window.history.replaceState({}, "", `?${params.toString()}`);
  }

  // Add Query String (Ensures only one query parameter at a time)
  addOnlyOneQueryString(key, value) {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    window.history.replaceState({}, "", `?${params.toString()}`);
  }

  // Reset Query String
  resetQueryString() {
    const params = new URLSearchParams();
    window.history.replaceState({}, "", `?${params.toString()}`);
  }

  // Update Multiple Parameter
  updateMultipleParameter(filter) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(filter)) {

      if (value) {
        params.append(key, `${value}`?.trim())
      }
    }

    if (params.has("page")) {
      params.delete("page");
    }

    return params.toString();

    // window.history.replaceState({}, "", `?${params.toString()}`);
  }

  // Fetch Updated Query Parameters
  fetchUpdatedQuery(search = window.location.search) {
    const fetchParams = new URLSearchParams(search);
    const updatedParams = Object.fromEntries(fetchParams.entries());
    return updatedParams;
  }

  showToast(msg, options) {
    return toast.success(msg, options);
  }

  dismissToastById(id) {
    toast.dismiss(id);
  }

  dismissAllToast() {
    toast.dismiss();
  }

  getQueryParams = (query = window.location.search) => {
    const queryStr = new URLSearchParams(query);
    const queryParams = {};
    queryStr.forEach((value, key) => {
      queryParams[key] = value;
    });
    return queryParams;
  };

  getQueryStrbyObj(obj, dateFormate = "YYYY-MM-DD") {
    if (!obj) return "";
    let params = new URLSearchParams();
    for (const [key, value] of Object.entries(obj)) {
      if (value) {
        if (value instanceof Date) {
          const dateStr = moment(value).format(dateFormate);
          params.append(key, dateStr);
        } else {
          params.append(key, value);
        }
      }
    }
    return params.toString();
  }

  debouncing(func, delay = 300) {
    let timeout;
    return function (...args){
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  getDownloadFileName(name = '', fileExtension = '.xlsx') {
    return `${name?.toLowerCase()?.replaceAll(" ", "_")}_${moment().format("DD-MM-YYYY_hh-mm-ss")}${fileExtension}`;
  }

  removeSingleKeyFromObj(obj, notAllowedKeys) {
    return Object.fromEntries(
      Object.entries(obj).filter(([key]) => !notAllowedKeys.includes(key))
    );
  }

  formateDate(date, formate = "DD MMM, YYYY HH:mm:ss") {
    if (!date)
      return ""
    return moment(date)?.format(formate)
  }

  categorizeDataBasedDash(data) {
    const [first, second] = data.split(" - ").map((str) => str.trim());
    return { first, second };
  }

  updateAngleBracketStr(str, val) {
    return str?.replace(/<.*?>/, val);
  }

  // Handle Open File From API
  async handleResourceView(evt, id) {
    evt.preventDefault();
    try {
      const response = await commonAPIInstance.fetchResourceUrlAPI(id);
      const linkUrl = response?.data?.link;
      if (linkUrl) {
        const link = document.createElement("a");
        link.href = linkUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.open("_blank")
        this.showToast("File opened successfully");
      } else {
        throw new Error("Resource link not found");
      }
    } catch (error) {
      console.error(error);
      this.showToast("Error opening file");
    }
  }
}

const helperInstance = new Helper();

export default helperInstance;
